import { gql } from "@/generated"

export const confirmOrgAdminEmailMutation = gql(`
  mutation ConfirmOrgAdminEmailAddress($input: ConfirmEmailAddressInput!) {
    confirmEmailAddress(input: $input) {
      user {
        id
        organization {
          id
          name
        }
      }
      errors {
        path
        fullMessages
      }
    }
  }
`)
